import { dialogStyles } from "../../../../../../Constants/dialogStyles";
import theme from "../../../../../../Constants/theme";

export const goldenResponsesSectionStyles = {
  ...dialogStyles.paperSection,
  maxHeight: "none",
  overflowY: "visible",
  height: "auto",
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  backgroundColor: theme.backgroundColors.dark.tertiary,
  flexDirection: "column",
};
